import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wm-export-data-activity-input',
    templateUrl: './export-data-activity-input.component.html',
    styleUrls: ['./export-data-activity-input.component.css'],
    standalone: false
})
export class ExportDataActivityInputComponent extends ActivityView
  implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}
}
